<template>
  <div class="response" :style="{'margin-left': levelResponse()}">
    <div class="response__avatar">
      <div class="response__avatar-img">
        <img :src="getImage(response.authorAvatar)" alt="" :title="response.author">
      </div>
    </div>
    <div class="response__header">
      <p class="response__author">{{ response.authorResponse }}</p>
      <div class="response__date">
        <p>{{ response.date }}</p>
      </div>
      <span class="response__header-info">в ответ {{ response.author }}</span>
    </div>
    <div class="response__content-wrap">
      <div v-if="formEditResponseShow === response.uuid">
        <form @submit.prevent="validationResponse('formEditResponse')" class="review__form">
          <label for="response"></label>
          <textarea id="response"
                    v-model="formEditResponse.response"
                    class="review__form-input review__form-input_not-mrb"
                    :class="{'reviews__form-input_warn': v$.formEditResponse.response.$error}"
                    placeholder=""></textarea>
          <div v-for="item in v$.formEditResponse.response.$errors" class="reviews__form-warning"
               :class="[{'reviews__form-warning_active': item}, 'reviews__form-warning_active-response']">
            {{ item.$message }}
          </div>
          <div class="button-form button-form__wrapper">
            <button class="button-link button-link_not-border">Сохранить изменения</button>
            <button class="button-link button-link_not-border" type="button" @click="closeForm()">Отменить изменения
            </button>
          </div>
        </form>
      </div>
      <div class="response__content" v-if="!(formEditResponseShow === response.uuid)">
        <div class="response__body">
          <p class="response__body-content" v-html="response.response"></p>
        </div>
        <div class="response__footer">
          <p class="response__footer-content">Вам помог этот ответ?</p>
          <div class="response__footer-buttons">
            <div class="response__button">
              <div class="button-like" @click="checkLikes">Да<span class="button-like__count">{{
                  response.reactions.ans_yes
                }}</span></div>
            </div>
            <div class="response__button">
              <div class="button-like" @click="checkDislikes">Нет<span class="button-like__count">{{
                  response.reactions.ans_no
                }}</span></div>
            </div>
            <div class="button-link" @click="toggleVisibilityFormResponse">
              {{ btnOpenFormResponse }}
              <span v-bind:class="formAddResponseShow ? 'closeForm' : ''"></span>
            </div>
            <div class="review__button review__button--status">
              <div class="review__status" v-if="user.isModerator">
                <IconBase :icon-name="response.moderated ? 'eye' : 'eye-off'" class="review__icon-status">
                  <IconEye v-if="response.moderated"/>
                  <IconEyeOff v-else/>
                </IconBase>
                {{ response.moderated ? "Виден всем" : "Отзыв скрыт" }}
              </div>
              <div v-if="user.isModerator || user.authorizedUser" class="button-dots"
                   @click="buttonPopupShow = !buttonPopupShow">
                <transition name="fade">
                  <div class="button-popup" v-show="buttonPopupShow">
                    <a v-if="user.isModerator" @click="markModerate" class="button-popup__link button-popup__item">
                      <IconBase icon-name="alert-circle" class="button-popup__icon">
                        <IconAlertCircle/>
                      </IconBase>
                      {{ moderateMessage }}
                    </a>
                    <a v-if="user.uuid === response.user_uuid" class="button-popup__link button-popup__item"
                       @click="openEditResponseForm">
                      <IconBase icon-name="pencil" class="button-popup__icon">
                        <IconPencil/>
                      </IconBase>
                      Редактировать
                    </a>
                    <a v-if="user.isModerator" class="button-popup__link button-popup__item" @click="deleteEntity">
                      <IconBase icon-name="delete" class="button-popup__icon">
                        <IconDelete/>
                      </IconBase>
                      Удалить
                    </a>
                    <!--                    <a v-else class="button-popup__link button-popup__item">-->
                    <!--                      <IconBase icon-name="delete" class="button-popup__icon"><IconAlertCircle /></IconBase>-->
                    <!--                      Пожаловаться-->
                    <!--                    </a>-->
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div v-if="formAddResponseShow">
            <form @submit.prevent="validationResponse('formAddResponse')" class="review__form">
              <label for="response"></label>
              <textarea id="response"
                        v-model="formAddResponse.response"
                        class="review__form-input"
                        :class="{'reviews__form-input_warn': v$.formAddResponse.response.$error}"
                        placeholder=""></textarea>
              <div v-for="item in v$.formAddResponse.response.$errors" class="reviews__form-warning"
                   :class="[{'reviews__form-warning_active': item}, 'reviews__form-warning_active-question']">
                {{ item.$message }}
              </div>
              <button :disabled="isOnSubmit" class="button-red">Отправить ответ</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import avatarDefault from '../assets/images/review-avatar-default.png';
import IconBase from "@/components/icon/IconBase";
import IconPencil from "@/components/icon/icons/IconPencil";
import IconAlertCircle from "@/components/icon/icons/IconAlertCircle";
import IconDelete from "@/components/icon/icons/IconDelete";
import IconEye from "@/components/icon/icons/IconEye";
import IconEyeOff from "@/components/icon/icons/IconEyeOff";
import IconHistory from "@/components/icon/icons/IconHistory";

import {useVuelidate} from '@vuelidate/core';
import {required, helpers} from '@vuelidate/validators';

export default {
  name      : "Response",
  props     : {
    response            : Object,
    reactions           : Object,
    user                : {
      type   : Object,
      require: true
    },
    formEditResponseShow: {
      type: [Boolean, String]
    },
  },
  components: {
    IconBase,
    IconPencil,
    IconAlertCircle,
    IconDelete,
    IconEye,
    IconEyeOff,
    IconHistory
  },
  data() {
    return {
      v$                 : useVuelidate(),
      buttonPopupShow    : false,
      isOnSubmit         : false,
      formEditResponse   : {
        response: '',
        parent_uuid: ''
      },
      formAddResponse    : {
        response   : '',
        parent_uuid: ''
      },
      uidInstance        : this.response.uuid,
      btnOpenFormResponse: this.user.authorizedUser ? 'Ответить' : 'Авторизоваться и ответить',
      formAddResponseShow: false,
    }
  },
  validations: {
    formEditResponse: {
      response: {
        required: helpers.withMessage("Заполните поле ответа", required),
      }
    },
    formAddResponse : {
      response: {
        required: helpers.withMessage("Оставьте отзыв", required),
      }
    }
  },
  methods    : {
    levelResponse() {
      return this.response.level <= 3 ? this.response.level * 40 + 'px' : 3 * 40 + 'px';
    },
    // для отображения изображений
    getImage(urlImg) {
      return urlImg.length === 0 ? avatarDefault : urlImg
    },
    toggleLike   : function () {
      let responseData = this.response.reactions;

      responseData.liked = !responseData.liked;

      responseData.liked ? responseData.ans_yes++ : responseData.ans_yes--;
    },
    toggleDislike: function () {
      let responseData = this.response.reactions;

      responseData.disliked = !responseData.disliked;

      responseData.disliked ? responseData.ans_no++ : responseData.ans_no--;
    },
    showAuth() {
      $('#f__auth').modal('show');
    },
    toggleVisibilityFormResponse() {
      if (this.user.authorizedUser) {
        this.formAddResponse.response = '';
        this.v$.$reset();
        if (this.formAddResponseShow || this.formEditResponseShow) {
          this.formAddResponseShow = false;
          this.btnOpenFormResponse = 'Ответить'
        } else {
          this.formAddResponseShow = true
          this.btnOpenFormResponse = 'Закрыть форму ответа'
        }
      } else {
        this.showAuth();
      }
    },
    checkLikes() {
      if (!this.$parent.user.authorizedUser) {
        this.showAuth();
        return;
      }
      const oldData = Object.assign({}, this.response.reactions);
      let responseData = this.response.reactions;

      if (responseData.disliked) {
        // убрать дизлайк
        this.toggleDislike();
        // добавить лайк
        this.toggleLike();
      } else {
        // добавить лайк
        this.toggleLike();
      }

      this.updateReactions(oldData);
    },
    checkDislikes() {
      if (!this.$parent.user.authorizedUser) {
        this.showAuth();
        return;
      }
      const oldData = Object.assign({}, this.response.reactions);
      let responseData = this.response.reactions;
      if (responseData.liked) {
        // убрать лайк
        this.toggleLike();
        // добавить дизлайк
        this.toggleDislike();
      } else {
        // добавить дизлайк
        this.toggleDislike();
      }

      this.updateReactions(oldData);
    },
    updateReactions(oldData) {
      let data = {
        idReview: this.response.uuid,
        // ...this.reactions
        liked   : this.response.reactions.liked,
        disliked: this.response.reactions.disliked,
        old     : oldData
      }
      this.$emit('updateResponse', data)
    },
    markModerate() {
      this.$parent.markModerate(this.response.uuid);
      this.response.moderated = !this.response.moderated;
    },
    onSubmit() {
      this.isOnSubmit = true;
      if (this.formEditResponseShow) {
        this.formEditResponse.parent_uuid = this.response.uuid;
        this.$emit('onSubmit', this.formEditResponse, this.response.uuid);
      } else {
        this.formAddResponse.parent_uuid = this.response.uuid;
        this.$emit('onSubmit', this.formAddResponse, '', true);
        this.toggleVisibilityFormResponse();
        this.isOnSubmit = false;
      }
    },
    openEditResponseForm() {
      this.$emit('openEditResponseForm', this.uidInstance);
    },
    closeForm() {
      this.formEditResponse.response = this.response.response;
      this.$emit('closeForm');
    },
    deleteEntity() {
      this.$emit('deleteEntity', this.uidInstance);
    },
    validationResponse(objectValidation) {
      this.v$[objectValidation].$validate();
      if (!this.v$[objectValidation].response.$error) {
        this.v$.$reset();
        this.onSubmit();
      }
    }
  },
  computed   : {
    moderateMessage: function () {
      return this.response.moderated ? 'Скрыть' : 'Показать'
    },
    isModerator    : function () {
      return this.$parent.user.isModerator;
    },
    // isAuthor: function () {
    //   return this.$parent.user.isAuthor;
    // },
    authorized: function () {
      return this.$parent.user.authorizedUser;
    }
  },
  mounted() {
    this.formEditResponse.response = this.response.response;
  }
}
</script>

<style scoped>

</style>